import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import 'hammerjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production == true) {
	enableProdMode();
	console.log = () => {}; // turn off for production
}

document.title = environment.company;

function bootstrap() {
	bootstrapApplication(AppComponent, appConfig).catch((err) => {
		console.error(err);
	});
}

if (window['cordova']) {
	document.addEventListener('deviceready', () => bootstrap());
} else {
	bootstrap();
}

declare var device;
function _window(): any {
	// return the global native browser window object
	return window;
}

_window().addEventListener('native.keyboardshow', (e) => {
	console.log(e.keyboardHeight);
	if (e && e.keyboardHeight > 0) {
		sessionStorage.setItem('keyboardHeight', e.keyboardHeight);
		sessionStorage.removeItem('scrollKeyboard');
	}
});

_window().addEventListener('native.keyboardhide', () => {
	document.body.style.paddingBottom = '0px';
});
